<template>
    <li
      class="operation flex flex-col gap-2 bg-white rounded-lg p-2 shadow-sm"
    >
      <!-- Ligne du haut : type d'op + quantité -->
      <div class="flex items-center gap-2 text-sm text-gray-800">
        <i :class="['inline-block', classTypeOp]"></i>
        <i class="inline-block h-5 w-5" :class="operation.type.includes('Retrait') ? 'bg-gris mask-goutte-moins' : 'bg-secondary mask-goutte-plus'"></i>
        <span class="font-medium">
          {{ operation.type }} | {{ operation.quantite }} Kg
        </span>
      </div>

      <!-- Ligne du bas : bouteille / fluide / delete -->
      <div class="bottom-op flex flex-wrap items-center gap-1 text-sm text-gray-700">

        <template v-if="bouteille">
          <div class="flex-none flex items-center gap-2 px-2 py-1 rounded-xl bg-white text-md font-medium"
              :class="bouteille.type === 'Fluide frigorigène' ? 'text-gaz-ff' : (bouteille.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')">
              <i class="inline-block h-5 w-5 mask mask-bouteille"
                  :class="bouteille.type === 'Fluide frigorigène' ? 'bg-gaz-ff' : (bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')"></i>
              <span>{{ bouteille.code }}</span>
          </div>

          <div v-if="bouteille.otag"
              class="flex-none flex items-center gap-2 px-2 py-1 rounded-xl bg-white text-md font-medium"
              :class="bouteille.type === 'Fluide frigorigène' ? 'text-gaz-ff' : (bouteille.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')">
              <i class="inline-block h-5 w-5 mask mask-otag"
                  :class="bouteille.type === 'Fluide frigorigène' ? 'bg-gaz-ff' : (bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')"></i>
              <span>{{ bouteille.otag }}</span>
          </div>

          <div v-if="fluide" class="flex-none flex items-center gap-2 px-2 p-1 rounded-xl text-white text-md font-medium"
              :class="bouteille.type === 'Fluide frigorigène' ? 'bg-gaz-ff' : (bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')">
              <div class="relative flex items-center">
                  <i class="inline-block h-5 w-5 bg-white mask mask-snow"></i>
              </div>
              <span>{{ fluide.nom }}</span>
          </div>

          <div class="ml-auto">
            <button
              v-show="bouteille.actif === true"
              @click.prevent="delOperation(operation.id)"
              class="inline-flex items-center justify-center bg-alert text-white rounded-full h-8 w-8 hover:opacity-90 transition"
            >
              <i class="inline-block h-5 w-5 mask mask-trash bg-white"></i>
            </button>
          </div>
        </template>

      </div>
    </li>
  </template>


<script>
    import Bouteille from '../../../../js/models/Bouteille'
    import OperationBouteille from '../../../../js/models/OperationBouteille'
    import Fluide from '../../../../js/models/Fluide'

    export default {

        data() {
            return {
                bouteille: null,
                fluide: null
            }
        },

        props: {
            operation: null,
        },

        computed: {
            classTypeOp() {
                if (_.includes(this.operation.type, 'Ajout')) {
                    return 'icon-add'
                } else {
                    return 'icon-less'
                }
            }
        },

        mounted() {

            Bouteille
                .getBouteille(this.operation.id_bouteille)
                .then(data => {
                    this.bouteille = data
                });

            var fobj = new Fluide();

            fobj
                .getFluide(this.operation.id_fluide, res => {
                    this.fluide = res
                })

        },

        methods: {

            async delOperation(id) {

                //Permet de récupérer la dernière version de la bouteille
                let bouteille = await Bouteille.getBouteille(this.operation.id_bouteille)

                if (this.bouteille.type !== "Fluide frigorigène") {

                    let nouveauPoids = bouteille.poids_net;
                    //Les id_type sont en string, donc pas de === :)
                    if (this.operation.id_type == "5") {
                        nouveauPoids = bouteille.poids_net - this.operation.quantite;
                    } else if (this.operation.id_type == "2") {
                        nouveauPoids = bouteille.poids_net + this.operation.quantite;
                    }

                    if (nouveauPoids < 0) {
                        swal('Incohérence', "Vous devez d'abord supprimer la manipulation d'ajout de fluide recyclé", 'question')
                        return false;
                    }

                }


                if (this.bouteille.actif === true) {

                    let ObjOp = new OperationBouteille();

                    ObjOp
                        .cancelOperation(id)
                        .then(res => {
                            this.$emit('opDeleted', [res])
                        })
                        .catch()

                } else {

                    swal('Action non autorisée', "La bouteille utilisée pour cette opération est maintenant clôturée", 'error')

                }

            }

        }

    }

</script>

<style>

    li.operation {
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid #ccc;
    }

    .operation:last-child {
        border-bottom: none;
    }

    div.bottom-op {
        padding-top: 7px;
        display: flex;
        justify-content: space-between;
    }

    div.bottom-op a {
        height: 40px;
        width: 40px;
        color: #fff;
        line-height: 40px;
        text-align: center;
        background-color: #c31616;
        border-radius: 5px;
        font-size: 2.3rem;
        display: block;
    }

    .bottle, .refrigerant {
        position: relative;
        height: 40px;
        width: auto;
        padding: 0 10px;
        color: white;
        font-size: 1.8rem;
        font-weight: 700;
        border-radius: 5px;
        line-height: 2;
        border: 1px solid transparent;
        background-color: #999;
    }

    .delete {
        width: 40px;
    }

    .refrigerant{
        background-color: #393c51;
    }

</style>



// WEBPACK FOOTER //
// OperationBouteille.vue?163fba5a